import { render } from "./PatientRegistration.vue?vue&type=template&id=50d9a770&scoped=true"
import script from "./PatientRegistration.vue?vue&type=script&lang=js"
export * from "./PatientRegistration.vue?vue&type=script&lang=js"

import "./PatientRegistration.vue?vue&type=style&index=0&id=50d9a770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d9a770"]])

export default __exports__